import type { IntlKey } from 'locales';
import { Component, FC, ReactNode } from 'react';

interface TabProps {
  children: ReactNode;
  tabId: string;
  label: IntlKey;
  className?: string;
  beforeLabel?: ReactNode;
  afterLabel?: ReactNode;
  e2eId: string;
  disabled?: boolean;
}

export type ChildrenTabArray = ReadonlyArray<Component<TabProps>>;
export const Tab: FC<TabProps> = ({ children }) => {
  return <>{children}</>;
};
